module.exports = __webpack_public_path__ + "img/kma_gallery14.a7e9f92f.jpg";